export default __webpack_public_path__ + "static/media/bgm-1.e2964f38.webp";